import { ARTICLE_MARKDOWN_REGEX } from 'modules/articles/constants'
import React from 'react'
import markdownToHtmlStringUtil from 'utils/string/markdown-to-html'
import { ArticleContentShare } from 'pages/Article/Content/components/ContentShare/index.js'
import { ArticleImageMarkdown } from 'pages/Article/Content/components/ImageMarkdown/index.js'
import { ArticleContentObject } from 'pages/Article/Content/components/ContentObject/index.js'
import { ArticleChunkMarkdown } from 'pages/Article/Content/components/ChunkMarkdown/index.js'
import {
  arePropsEqualComponentUtil,
  getObjectUtil
} from 'packages/src'

/**
 * @param props
 * @param props.index
 * @param props.chunk
 * @param props.propsToPassToShare
 * @param props.url
 * @param props.imageIndexRef
 * @return {React.JSX.Element}
 * @constructor
 */
function ArticleChunkContent (props) {
  const {
    index,
    propsToPassToShare,
    imageIndexRef,
    url
  } = props
  let { chunk } = props

  const image = getObjectUtil(ARTICLE_MARKDOWN_REGEX.IMG.exec(chunk), '0')
  const imgMarkdown = image && markdownToHtmlStringUtil(image)
  chunk = chunk.replace(ARTICLE_MARKDOWN_REGEX.IMG, '')

  const contentObjectResult = ARTICLE_MARKDOWN_REGEX.OBJECT.exec(chunk)
  let contentObject
  if (contentObjectResult) {
    // e.g. '{className:Plan,id:1}' becomes an object
    contentObject = contentObjectResult[0]
      .split(',')
      .reduce((
        obj,
        keyValuePair
      ) => {
        const [key, value] = keyValuePair.split(':')
        obj[key.replace(/{|}/g, '')] = value.replace(/{|}/g, '')
        return obj
      }, {})
    chunk = chunk.replace(ARTICLE_MARKDOWN_REGEX.OBJECT, '')
  }

  return (
    <>
      {
        image && (
          <ArticleImageMarkdown
            imgMarkdown={imgMarkdown}
            imageIndexRef={imageIndexRef}
          />
        )
      }

      <ArticleChunkMarkdown
        chunk={chunk}
        url={url}
      />

      {
        image && (
          <ArticleContentShare
            isImage
            index={index}
            {...propsToPassToShare}
          />
        )
      }

      {
        !!contentObject && (
          <ArticleContentObject
            contentObject={contentObject}
          />
        )
      }
    </>
  )
}

export default React.memo(
  ArticleChunkContent,
  arePropsEqualComponentUtil()
)
